import React, { useState, useEffect } from 'react';
import { Button } from './button';
import { Card, CardContent, CardHeader, CardTitle } from './card';
import { AlertTriangle, X } from 'lucide-react';

// Global error state - simple module-level state
let errorState = {
  isOpen: false,
  message: '',
  onClose: null
};

// Listeners for error state changes
const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach(listener => listener(errorState));
};

// Global function to show error modal
export const showServerError = (message) => {
  errorState = {
    isOpen: true,
    message: message || 'A server error occurred. Please try again later.',
    onClose: () => {
      errorState = { ...errorState, isOpen: false };
      notifyListeners();
    }
  };
  notifyListeners();
};

const ErrorModal = () => {
  const [state, setState] = useState(errorState);

  useEffect(() => {
    const listener = (newState) => {
      setState(newState);
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  if (!state.isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 transition-opacity"
        onClick={state.onClose}
      />
      
      {/* Modal */}
      <Card className="relative w-full max-w-md mx-4 shadow-lg">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-2 text-lg">
              <AlertTriangle className="h-5 w-5 text-red-500" />
              Server Error
            </CardTitle>
            <Button
              variant="ghost"
              size="sm"
              onClick={state.onClose}
              className="h-6 w-6 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {state.message}
          </p>
          <div className="flex justify-end">
            <Button
              variant="destructive"
              onClick={state.onClose}
              className="w-full sm:w-auto"
            >
              OK
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ErrorModal;

